var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sparkle",
    clipPath: "url(#clip0_0_1058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.68052 1.11377C5.59075 1.18832 5.52989 1.29192 5.50846 1.40663L4.98292 4.18585C4.94559 4.38344 4.84957 4.56519 4.70738 4.70738C4.56519 4.84957 4.38344 4.94559 4.18585 4.98292L1.40663 5.50846C1.29192 5.52989 1.18832 5.59075 1.11377 5.68052C1.03921 5.77029 0.9984 5.88331 0.9984 6C0.9984 6.11669 1.03921 6.22971 1.11377 6.31948C1.18832 6.40925 1.29192 6.47011 1.40663 6.49154L4.18585 7.01708C4.38344 7.05441 4.56519 7.15043 4.70738 7.29262C4.84957 7.43481 4.94559 7.61656 4.98292 7.81415L5.50846 10.5934C5.52989 10.7081 5.59075 10.8117 5.68052 10.8862C5.77029 10.9608 5.88331 11.0016 6 11.0016C6.11669 11.0016 6.22971 10.9608 6.31948 10.8862C6.40925 10.8117 6.47011 10.7081 6.49154 10.5934L7.01708 7.81415C7.05441 7.61656 7.15043 7.43481 7.29262 7.29262C7.43481 7.15043 7.61656 7.05441 7.81415 7.01708L10.5934 6.49154C10.7081 6.47011 10.8117 6.40925 10.8862 6.31948C10.9608 6.22971 11.0016 6.11669 11.0016 6C11.0016 5.88331 10.9608 5.77029 10.8862 5.68052C10.8117 5.59075 10.7081 5.52989 10.5934 5.50846L7.81415 4.98292C7.61656 4.94559 7.43481 4.84957 7.29262 4.70738C7.15043 4.56519 7.05441 4.38344 7.01708 4.18585L6.49154 1.40663C6.47011 1.29192 6.40925 1.18832 6.31948 1.11377C6.22971 1.03921 6.11669 0.9984 6 0.9984C5.88331 0.9984 5.77029 1.03921 5.68052 1.11377Z",
    stroke: "#6E6E6E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle1);
export default __webpack_public_path__ + "static/media/sparkle-1.29a8fb01f8a89c02273bb7efde47526d.svg";
export { ForwardRef as ReactComponent };